import React, { Component } from "react";
import { Formik } from "formik";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
// import ReCAPTCHA from "react-google-recaptcha";S

import { Checkbox, notification } from "antd";
import * as Yup from "yup";

/* Styles */
import {
  Container,
  DisplayBody,
  DisplayBodyMessage,
  DisplayContainer,
  DisplayFooter,
  DisplayHeader,
  FormContainer,
  LoginContainer,
  LogoContainer,
  Wrapper,
} from "./styles";

import displayImage from "../../assets/images/display_image.png";

/* Components */
import ContactUsModal from "../../components/modals/contactUs";
import ButtonStandard from "../../components/utils/button";
import FacebookIcon from "../../components/utils/icons/facebook/facebookHome";
import InstagramIcon from "../../components/utils/icons/instagram/instagramHome";
import LinkedinIcon from "../../components/utils/icons/linkedin/linkedinHome";
import InputStandard from "../../components/utils/input";
import Loading from "../../components/utils/loading";

/* Images */
import LogoBull from "../../components/login/logos/logoBull";
import LogoVertical from "../../components/login/logos/logoVertical";

/* Redux Actions */
import { Creators as AppActions } from "../../store/ducks/app";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      showPassword: false,
      showCaptcha: false,
      authorized: true,
      attempts: 1,
      captchaKey: process.env.REACT_APP_RECAPTCHA_KEY,
      captchaActive: process.env.REACT_APP_RECAPTCHA_ACTIVATE,
      form: {
        username: "",
        password: "",
        remember_me: false,
      },
    };
  }

  static propTypes = {
    appActions: PropTypes.shape({
      authenticate: PropTypes.func.isRequired,
    }).isRequired,
    app: PropTypes.shape({
      isLooged: PropTypes.bool,
      token: PropTypes.string,
    }).isRequired,
  };

  openCloseMenu = () => this.setState({ menuOpen: !this.state.menuOpen });

  openContactUsModal = () => {
    const { appActions } = this.props;
    appActions.showModalContactUs();
  };

  handleLogin = async (values, actions) => {
    const {
      appActions,
      app: { attemptsLogin },
    } = this.props;
    const { authorized, attempts, captchaActive } = this.state;
    const { username, password, remember_me } = values;

    const { translation } = this.props.app;
    if (authorized) {
      appActions.authenticate(username, password, remember_me);
      // this.setState({
      //   attempts: attempts + attemptsLogin,
      // });
      // if (attempts === 3 && captchaActive === "true") {
      //   this.setState({
      //     authorized: false,
      //     showCaptcha: true,
      //     attempts: 1,
      //   });
      // }
    } else {
      notification.error({ message: translation.login.messages.notRobot });
    }
  };

  handleCaptcha = () => {
    this.setState({
      authorized: true,
    });
  };

  render() {
    const {
      app: { isLogged, token, isLoading, user, translation },
    } = this.props;
    const { showPassword, showCaptcha, captchaKey, form } = this.state;
    const validationSchema = Yup.object().shape({
      username: Yup.string()
        .email("Digite um e-mail válido")
        .required("É preciso informar um e-mail"),
      password: Yup.string().required("É preciso informar uma senha"),
    });

    if (isLogged && token !== "") {
      if (user.isInputSupplier) {
        return <Redirect to="/supplier" />;
      } else {
        return <Redirect to="/admin" />;
      }
    }

    return (
      <Wrapper>
        {isLoading && <Loading />}
        <Container>
          <LoginContainer>
            <LogoContainer>
              <LogoVertical />
            </LogoContainer>
            <FormContainer marginTop={showCaptcha}>
              <span className="title">{translation.login.title}</span>
              <span className="subTitle">
                {translation.login.subtitle}
              </span>
              <Formik
                initialValues={form}
                onSubmit={this.handleLogin}
                validationSchema={validationSchema}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  ...props
                }) => (
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <label>{translation.login.loginLabel}</label>
                    <InputStandard
                      width="100%"
                      border={
                        !touched.username || isLoading
                          ? "normal"
                          : errors.username
                          ? "error"
                          : "success"
                      }
                    >
                      <input
                        type="email"
                        value={values?.username}
                        autoCapitalize="off"
                        placeholder={translation.login.usernamePlaceholder}
                        name="username"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          props.setFieldValue(
                            "username",
                            e.target.value.toLowerCase()
                          );
                          this.setState({
                            form: {
                              ...this.state.form,
                              username: e.target.value.toLowerCase(),
                            },
                          });
                        }}
                        disabled={!!isLoading}
                      />
                    </InputStandard>
                    {touched.username && errors.username ? (
                      <span className="error">{errors.username}</span>
                    ) : null}
                    <label>{translation.login.passwordLabel}</label>
                    <InputStandard
                      width="100%"
                      border={
                        !touched.password || isLoading
                          ? "normal"
                          : errors.password
                          ? "error"
                          : "success"
                      }
                    >
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder={translation.login.passwordPlaceholder}
                        name="password"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        disabled={!!isLoading}
                      />
                    </InputStandard>
                    {touched.password && errors.password ? (
                      <span className="error">{errors.password}</span>
                    ) : null}
                    <Checkbox
                      onChange={() =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                      }
                      style={{
                        color: "#4B4B4B",
                        fontWeight: "normal",
                        textTransform: "none",
                        marginTop: 10,
                      }}
                    >
                      {translation.login.showPassword}
                    </Checkbox>
                    {/* <div className="captcha">
                      {showCaptcha ? (
                        <ReCAPTCHA
                          sitekey={captchaKey}
                          onChange={this.handleCaptcha}
                        />
                      ) : null}
                    </div> */}

                    {/* <Checkbox
                      name="remember_me"
                      checked={values.remember_me}
                      onChange={handleChange}
                      style={{
                        color: "#4B4B4B",
                        fontWeight: "normal",
                        textTransform: "none",
                        marginTop: 10
                      }}
                    >
                      Manter conectado ?
                    </Checkbox> */}

                    <div className="formFooter">
                      <ButtonStandard
                        disabled={isLoading}
                        buttonType="type1"
                        size="m"
                      >
                        {translation.login.submitButton}
                      </ButtonStandard>

                      <span className="forgotPasswordSpan">
                        {translation.login.forgotPassword}
                        <Link
                          to="/change/password"
                          className="forgotPasswordLink"
                        >
                          {translation.login.forgotPasswordLink}
                        </Link>
                      </span>
                    </div>
                  </form>
                )}
              </Formik>
            </FormContainer>
          </LoginContainer>
          <DisplayContainer>
            <DisplayBody style={{ backgroundImage: `url(${displayImage})` }}>
              <DisplayHeader>
                <span onClick={this.openContactUsModal}>{translation.common.nav.contactUs}</span>
                <span className="border">{translation.common.nav.aboutUs}</span>
                <span>{translation.common.nav.support}</span>
              </DisplayHeader>
              <DisplayBodyMessage>
                <LogoBull />
                <span>
                  {translation.common.marketingTagline}
                </span>
              </DisplayBodyMessage>
              <DisplayFooter>
                <span>
                  <FacebookIcon />
                </span>
                <span>
                  <LinkedinIcon />
                </span>
                <span className="pad">
                  <InstagramIcon />
                </span>
              </DisplayFooter>
            </DisplayBody>
          </DisplayContainer>
        </Container>
        <ContactUsModal />
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
});

const mapDispatchToProps = (dispatch) => ({
  appActions: bindActionCreators(AppActions, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
